module.exports = __webpack_public_path__ + "static/img/lang_black.425f1707.svg";